import { observable, makeObservable } from 'mobx';
import { assignParams } from '@utils/assignParams';

import { UserModuleConfiguration } from '@user/configuration';
import { ProfileModuleConfiguration } from '@profile/ui/ProfilePage/configuration';

export interface ConfigurationParams {
    userModule: UserModuleConfiguration;
    profileModule: ProfileModuleConfiguration;
}

import { FeatureToggle } from './FeatureToggle';
import { userModule } from '@chaika/configuration/user/configration';
import { profileModule } from '@chaika/configuration/profile/configration';

export class Configuration {
    public static Name = 'configuration' as const;

    public readonly userModule!: UserModuleConfiguration;
    public readonly profileModule!: ProfileModuleConfiguration;

    @observable public featureToggle = new FeatureToggle();

    constructor(params: ConfigurationParams) {
        makeObservable(this);
        assignParams<ConfigurationParams>(this, params);
    }
}

export const configuration = new Configuration({
    userModule,
    profileModule,
});
